import React, { FC } from "react";
import styles from './RequiredField.module.scss';

const RequiredField: FC = () => {
  return <span className={styles.requiredAsterisk}>*</span>;
};

export default RequiredField;